






























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { gallerys } from "@/config/host.config";

import InputSearch from "@/components/app/search/input-search.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import ContextMenu from "@/components/buttons/context-menu.vue";

import { IPhotoFormat } from "@/@types/gallsery/gallery";
import axios from "@/api/AuthAPI/auth-request-api";
import { deleteElement } from "@/api/delite/delite-element";

@Component({ components: { InputSearch, ChangeDeliteButtons, ContextMenu } })
export default class GalleryFormatRecuclerList extends Vue {
  @Prop({ type: Array, default: () => [] }) formatList!: Array<IPhotoFormat>;
  search = "";
  idFormat = "";
  constxtID = "";
  $refs!: {
    menu: ContextMenu;
  };

  get formats(): Array<IPhotoFormat> {
    return this.formatList.filter((item) => {
      return (
        this.$getLocale(item.name)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) > -1
      );
    });
  }

  handler(e: PointerEvent, id: string | undefined): void {
    e.preventDefault();
    if (!id) return;
    this.$nextTick(() => {
      this.$refs.menu.contextX = e.clientX;
      this.$refs.menu.contextY = e.clientY;
      this.$refs.menu.showContext = true;
      this.constxtID = id;
    });
  }

  deleteFormat(id: string): void {
    const uri = gallerys.formatForce;
    deleteElement(id, uri)
      .then(() => {
        this.$emit("update", id);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        return;
      })
      .catch(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  async restoreFormat(id: string | undefined): Promise<void> {
    if (!id) return;
    const uri = gallerys.formatRestore + "/" + id;
    try {
      const res = await axios.put(uri);
      if (res.status === 200) {
        this.$emit("update", id);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }
}
